<template>
  <div>
    <v-card>
      <h1 class="pl-5 pr-5">Individuals</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <FulfillmentStatus ref="fulfillmentStatus" />
      <div class="row pl-5 pr-5" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="textSearch"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="subscriptionType"
            v-model="paging.isASC"
            :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="getOrganizationByPagin()"
          ></v-select>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Individual
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-stepper v-model="purchaseStep">
          <v-stepper-header>
            <v-stepper-step :complete="purchaseStep > 1" step="1" @click="purchaseStep = 1">
              Individual Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="purchaseStep > 2" step="2" @click="() => { if (this.id !== 0) { purchaseStep = 2; } }">
              Assignment
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="row">
                <div class="col">
                  <v-text-field
                    id="individualName"
                    label="Name *"
                    v-model="selectedObj.Name"
                    :rules="individualRules"
                    required
                  ></v-text-field>
                </div>
                <div class="col">
                  <v-text-field
                    id="individualAddress"
                    label="Address"
                    v-model="selectedObj.Address"
                  ></v-text-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select
                    id="Country"
                    v-model="selectedObj.country"
                    :items="countries"
                    label="Country"
                    item-text="CountryName"
                    item-value="id"
                    return-object
                  ></v-select>
                </div>
                <div class="col">
                  <v-text-field
                    id="individualPhone"
                    label="Phone"
                    v-model="selectedObj.phone"
                  ></v-text-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-text-field
                    id="individualEmail"
                    label="Email"
                    v-model="selectedObj.subscriptionAdminEmail"
                    :rules="adminEmailRules"
                    required
                  ></v-text-field>
                </div>
                <div class="col">
                    <v-select
                    id="subscriptionType"
                    v-model="selectedObj.subscriptionType"
                    :items="[{type:'Regular'}, {type:'Test'}, {type:'Partner'}, {type:'Internal'}]"
                    label="Subscription Type"
                    item-text="type"
                    item-value="type"
                    return-value="type"
                  ></v-select>
                </div>
              </div>
              <div class="row">
                  <div class="col">
                    <v-text-field
                      id="password_hint"
                      v-model="passwordHint"
                      label="Password Hint"
                      required
                      v-show="!isEditPassword"
                    ></v-text-field>
                  </div>
                  <div class="col">
                  <v-text-field
                      id="subscription_admin_password"
                      v-model="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      label="Password"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                      :rules="passwordRules"
                      required
                      v-show="!isEditPassword"
                    ></v-text-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="float-right">
                      <v-dialog v-model="dialog" persistent max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            id="btnPassword"
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1 mb-2"
                            @click="onOpenSetPassword()"
                            v-show="isEditPassword"
                          >
                            Set Password
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">Password</span>
                          </v-card-title>
                          <v-card-text>
                            <v-divider></v-divider>
                            <Notification :notify="notifyPassword" />
                            <v-row>
                              <v-col>
                                <v-text-field
                                  id="passwordHint"
                                  v-model="passwordHint"
                                  label="Password Hint*"
                                  required
                                  counter
                                >
                                </v-text-field
                              ></v-col>
                              <v-col>
                                <v-text-field
                                  id="password"
                                  v-model="password"
                                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="show1 ? 'text' : 'password'"
                                  name="input-10-1"
                                  label="Password*"
                                  hint="At least 6 characters"
                                  counter
                                  :rules="passwordRules"
                                  @click:append="show1 = !show1"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              id="btnClose"
                              color="blue darken-1 mr-2"
                              text
                              @click="dialog = false"
                            >
                              Close
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="onSavePassword()" id="btnSave">
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </div>
                </div>

              
              <v-divider  class="pt-5"></v-divider>
              <div class="row mb-4">
                <div class="col">
                  <div class="float-right action-area">
                    <v-btn @click="onCancel()" id="btnCancel" class="mr-2"> Cancel </v-btn>
                    <v-btn
                      id="btnSave"
                      class="mr-2"
                      color="primary"
                      @click="onSave()"
                      :loading="loading"
                      :disabled="loading"
                    >
                      Save
                    </v-btn>
                    <v-btn class="" @click="onStepperStep2" id="nxtbtn" :disabled="this.id == 0"
                          >Assign Collections</v-btn
                        >
                  </div>
                </div>
              </div>
            </v-form>
            </v-stepper-content>
            <v-stepper-content step="2">
                  <v-card class="mb-4">
                    <v-toolbar dark color="primary" dense>
                      <v-toolbar-title class="text-body-1">
                        Current Assignments for {{ selectedObj.Name }}
                      </v-toolbar-title>
                    </v-toolbar>

                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th style="width: 300px" class="text-left">Name</th>
                              <th style="width: 500px" class="text-left">Description</th>
                              <th style="width: 200px" class="text-left">Start Date</th>
                              <th class="text-left " style="width: 200px">End Date</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in subscriptionHistory" :key="item.id" v-if="new Date(item.endDate) > new Date()">
                              <td>{{ item.Name }}</td>
                              <td>{{ item.Description }}</td>
                              <td>{{ item.startDate | dateUtcToLocal }}</td>
                              <td>{{ item.endDate | dateUtcToLocal }}</td>
                              <td>
                                <v-btn small color="error" @click="removeAssignment(item)">Remove</v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <div v-if="historyLoading" class="pt-3">Loading history...</div>
                    </v-card-text>
                  </v-card>

            <h1>Collections Assignment</h1>
            <v-divider></v-divider>

  <!-- Common Date Pickers Outside Table -->
                  <div class="row">
                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="satrtDateAction"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            id="startDate"
                            v-model="satrtDate"
                            prepend-icon="mdi-calendar"
                            label="Start date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'Start date is required']"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          id="startDatePic"
                          v-model="satrtDate"
                          @input="satrtDateAction = false"
                          :max="endDate"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-menu
                        v-model="endDateAction"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            id="enddate"
                            v-model="endDate"
                            prepend-icon="mdi-calendar"
                            label="End date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'End date is required']"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          id="endDatePic"
                          v-model="endDate"
                          @input="endDateAction = false"
                          :min="satrtDate"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </div>

  <!-- Table -->
                  <div class="row">
                    <v-col cols="12">
                      <v-data-table
                        v-model="selected_fulfillment"
                        :headers="fulfillment_headers"
                        :items="availableCollections"
                        class="elevation-1"
                        show-select
                        id="fulfillment"
                      >
                        <template v-slot:item.name="props">
                          <p class="text-wrap">{{ props.item.name }}</p>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>

  <!-- Buttons -->
                  <div class="row">
                    <div class="col d-flex justify-end">
                      <div class="ms- 6 col d-flex justify-start">
                        <v-btn class="" @click="purchaseStep = 1" id="btnback"
                          >Back</v-btn
                        >
                      </div>
                      <div class="col d-flex justify-end">
                        <v-btn class="mr-2" @click="getSubcriptionHistory()">
                          Subscription History
                        </v-btn>
                        <v-btn
                          color="primary"
                          class=""
                          id="submit-assignment"
                          @click="createFulfillment()"
                          :loading="loading"
                          :disabled="loading"
                          >Assign And Submit</v-btn
                        >
                      </div>
                    </div>
                  </div>
              </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <ConfirmationDialog ref="confirm" />
      </div>
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" @click="sortByName" style="cursor: pointer">
                    Individual Name
                  </th>
                  <th class="text-left" @click="sortByAddress" style="cursor: pointer">
                    Address
                  </th>
                  <th class="text-left" @click="sortByCountry" style="cursor: pointer">
                    Country
                  </th>
                  <th class="text-left" @click="sortBySubscriptionType" style="cursor: pointer">
                    Subscription Type
                  </th>
                  <th class="text-left" @click="sortByStartDate" style="cursor: pointer">
                    Start Date
                  </th>
                  <th class="text-left" @click="sortByEndDate" style="cursor: pointer">
                    End Date
                  </th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Address }}</td>
                  <td>
                    {{ item.country != null ? item.country.CountryName : "" }}
                  </td>
                  <!---->
                  <td>{{ item.subscriptionType }}</td>
                  <td> 
                    {{ item.earliestSubscriptionStartDate | dateUtcToLocal }}
                  </td>
                  <td>
                    {{ item.earliestSubscriptionEndDate | dateUtcToLocal }}
                  </td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import PurchasedCollections from "@/components/PurchasedCollections";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import moment from "moment";
import * as api from "@/api";
import FulfillmentStatus from "../components/FulfillmentStatus.vue";
export default {
  name: "Individuals",
  components: {
    Notification,
    Pagination,
    PurchasedCollections,
    ConfirmationDialog,
    FulfillmentStatus
  },
  computed: {
    availableCollections() {
      const now = new Date();

      const activeIds = new Set(
        this.subscriptionHistory
          .filter(row => new Date(row.endDate) > now)
          .map(row => row.collectionId || row.CollectionId || row.id)
          .filter(Boolean)
      );

      return this.collectionList.filter(item => !activeIds.has(item.id));
    },

  },
  created() {
    this.getCountries();
    this.getOrganizationByPagin();
  },
  mounted() {
    this.getCollections();
  },
  methods: {
    async removeAssignment(item) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .update("lending/cancel/" + item.id, {"id":0})
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                new Promise((resolve, reject) => {
                  api
                    .DeleteByID("purchase-order/cancel", item.purchaseOrderId)
                    .then((response) => {
                      resolve(response);
                      this.loadSubscriptionHistory();
                    })
                    .catch((error) => {
                      reject(error);
                    });
                });
              }
            })
            .catch((error) => {});
        });
      }
    },

    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getOrganizationByPagin();
    },
    getOrganizationByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization/individuals", this.paging)
          .then((response) => {
            that.overlay = false
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
            that.loadEarliestSubscriptionDates(this.list);
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    getEarliestSubscriptionSummary(purchaseOrders) {
      if (!purchaseOrders || purchaseOrders.length === 0) {
        return null;
      }

      let earliest = null;

      purchaseOrders.forEach((order) => {
        const details =
          order && Array.isArray(order.PurchaseDetails)
            ? order.PurchaseDetails
            : [];

        details.forEach((detail) => {
          const endDate = detail.EndDate || detail.endDate;
          if (!endDate) {
            return;
          }

          const endMoment = moment(endDate);
          if (!endMoment.isValid()) {
            return;
          }

          if (!earliest || endMoment.isAfter(earliest.endMoment)) {
            earliest = {
              startDate: detail.StartDate || detail.startDate || null,
              endDate: endDate,
              endMoment: endMoment,
            };
          }
        });
      });

      if (!earliest) {
        return null;
      }

      return {
        startDate: earliest.startDate,
        endDate: earliest.endDate,
      };
    },
    loadEarliestSubscriptionDates(list) {
      if (!list || list.length === 0) {
        return;
      }

      const requestPaging = {
        count: 10,
        page: 1,
        size: 1000,
        keyword: "",
        isIndividual: false,
      };

      const requests = [];

      list.forEach((item) => {
        if (!item || !item.id) {
          return;
        }

        this.$set(item, "earliestSubscriptionStartDate", "");
        this.$set(item, "earliestSubscriptionEndDate", "");

        const request = api
          .getByPagin(
            "purchase-order/organization-collection/" + item.id,
            requestPaging
          )
          .then((response) => {
            const purchaseOrders = response.data && response.data.data
              ? response.data.data.filter(po => po.IsCancel === false)
              : [];
            const summary = this.getEarliestSubscriptionSummary(purchaseOrders);
            const startDate = summary ? summary.startDate : "";
            const endDate = summary ? summary.endDate : "";

            this.$set(item, "earliestSubscriptionStartDate", startDate);
            this.$set(item, "earliestSubscriptionEndDate", endDate);
          })
          .catch(() => {
            this.$set(item, "earliestSubscriptionStartDate", "");
            this.$set(item, "earliestSubscriptionEndDate", "");
          });

        requests.push(request);
      });

      if (requests.length > 0) {
        Promise.all(requests);
      }
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Address = "";
      this.selectedObj.UserLimit = 1;
      this.selectedObj.LicenseLimit = 0;
      this.selectedObj.LendingDuration = 14;
      this.valid = false;
      this.selectedObj.subscriptionAdminEmail = "";
      this.selectedObj.id = 0;
      this.userDetails = {};
      this.isEditPassword = false;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid){
         that.overlay = false;
         return;
      }
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("organization", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log("respoinse" ,response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.id = this.id !== 0 ? this.id : response.data.id;
              this.selectedObj.id = this.id;
              this.getOrganizationByPagin();
              return response.data;
            } else {
              that.overlay = false
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              return Promise.reject("Failed to save data.");
            }
          })
          .then((data) => {
            var userObj = {};
            if (data.id > 0) {
              userObj = {
                id: 0,
                firstName: this.selectedObj.Name,
                lastName: "",
                email: this.selectedObj.subscriptionAdminEmail,
                phone: this.selectedObj.phone,
                organization: this.selectedObj,
                isOrganizationUser: true,
                password: this.password,
                passwordhint: this.passwordHint,
                userRole:{
                  id: 3,
                  isOrganization: true,
                  roleKey: "PortalAdmin",
                  roleName: "Portal Admin"
                }
              };
            } else {
              if (this.userDetails && this.userDetails.id != undefined) {
                  userObj = {
                  id: this.userDetails.id,
                  firstName: this.selectedObj.Name,
                  lastName: "",
                  email: this.selectedObj.subscriptionAdminEmail,
                  phone: this.selectedObj.phone,
                  organization: this.selectedObj,
                  isOrganizationUser: true,
                  userRole:{
                    id: 3,
                    isOrganization: true,
                    roleKey: "PortalAdmin",
                    roleName: "Portal Admin"
                  }
                };
              } else {
                userObj = {
                  id: 0,
                  firstName: this.selectedObj.Name,
                  lastName: "",
                  email: this.selectedObj.subscriptionAdminEmail,
                  phone: this.selectedObj.phone,
                  organization: this.selectedObj,
                  isOrganizationUser: true,
                  password: this.password,
                  passwordhint: this.passwordHint,
                  userRole:{
                    id: 3,
                    isOrganization: true,
                    roleKey: "PortalAdmin",
                    roleName: "Portal Admin"
                  }
                }
              }
            }
            api
            .update("user", userObj)
            .then((response) => {
              resolve(response);
              console.log(response.status);
              console.log("respoinse" ,response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.isEditPassword = true;
                this.selectedObj.id = this.id;
                this.purchaseStep = 2;
                if (that.id == 0) {
                  this.notify.message = "Record successfully created.";
                } else {
                  this.notify.message = "Record successfully updated.";
                }
                this.getPortalUserDetails();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                that.overlay = false
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth',
                });
              }
              that.overlay = false
            }).catch((error) => {
              that.overlay = false
              this.notify.type = 4;
              this.notify.errors.push("Failed to save user data. Email might be already in use. Please change the email and try again.");
              this.isEditPassword = this.userDetails.id != undefined ? true : false;
              console.log(error);
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              reject(error);
            });
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Individual name already exist");
              this.loading = false;
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              console.log(error);
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              reject(error);
            }
            that.overlay = false
          });
      });
      // this.isEdit = false;
      // this.$refs.form.reset();
    },
  onStepperStep1() {
    this.purchaseStep = 1;
  },

  async onStepperStep2() {
    this.purchaseStep = 2;
    await this.loadSubscriptionHistory();
  },

    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
      this.id = obj.id;
      // this.satrtDate = obj.earliestSubscriptionStartDate.split("T")[0]
      this.satrtDate = new Date().toISOString().split("T")[0];
      this.endDate = obj.earliestSubscriptionEndDate.split("T")[0] > new Date().toISOString().split("T")[0] ? obj.earliestSubscriptionEndDate.split("T")[0] : this.satrtDate;
      this.getPortalUserDetails();
      this.isEditPassword = true;
      this.loadSubscriptionHistory();
    },
    async getPortalUserDetails() {
      new Promise((resolve, reject) => {
          api
            .getByID("user/organization", this.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                console.log(response.data);
                this.userDetails = response.data.filter(x => x.userRole.id === 3)[0];
                this.passwordHint = this.userDetails.passwordhint;
              }
            })
        });
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getOrganizationByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.id = 0;
      this.$refs.form.reset();
    },
    getOrganization() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization/individuals")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCountries() {
      this.countries = [];
      new Promise((resolve, reject) => {
        api
          .getAll("country")
          .then((response) => {
            this.countries = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCollections() {
      let that = this;
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then((response) => {
            console.log(response);
            response.data.forEach((e) => {
              e.satrtDate = "";
              e.endDate = "";
              that.collectionList.push(e);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async createFulfillment() {
        this.notify = {
          type: 0,
          message: "",
          errors: [],
        };

        let that = this;
        that.overlay = true;

        /* validate selected collections */
        if (
          !that.selected_fulfillment ||
          that.selected_fulfillment.length === 0
        ) {
          that.overlay = false;
          this.notify.type = 4;
          this.notify.errors.push(
            "Please select at least one collection to assign."
          );
          return;
        }

        /* validate common dates outside table */
        if (!this.satrtDate || !this.endDate) {
          that.overlay = false;
          this.notify.type = 4;
          this.notify.errors.push(
            "Start date and End date are required."
          );
          return;
        }
        // Process each selected collection individually
        const promises = that.selected_fulfillment.map((collection) => {
          let purchaseReqeust = {
            id: 0,
            Amount: 0,
            DateOfPayment: moment().toDate(),
            ReferenceNo: process.env.DEFAULT_REFERENCE_NO,
            PaymentMadeBy: process.env.DEFAULT_PAYER,
            PaymentConfirmed: true,
            IsCollection: true,
            OrganizationId: this.id,
            PurchaseDetails: [
              {
                NoOfCopies: Number(this.selectedObj.UserLimit),
                StartDate: moment(this.satrtDate).toDate(),
                EndDate: moment(this.endDate).toDate(),
                PublicationId: collection.PublicationId,
                collectionId: collection.id,
                journalId: collection.journalId,
                id: 0,
                collectionType: collection.collectionType,
              }
            ],
          };

          return new Promise((resolve, reject) => {
            api
              .update("purchase-order", purchaseReqeust)
              .then((response) => {
                resolve({
                  response: response,
                  collection: collection,
                  success: response.status === 200 || response.status === 201
                });
              })
              .catch((error) => {
                resolve({
                  response: null,
                  collection: collection,
                  success: false,
                  error: error
                });
              });
          });
        });

        // Wait for all promises to complete
        const results = await Promise.all(promises);

        // Process results
        let successCount = 0;
        let errorCount = 0;
        const errors = [];

        results.forEach(result => {
          if (result.success) {
            successCount++;
          } else {
            errorCount++;
            if (result.error) {
              errors.push(`Failed to save data for collection ${result.collection.name}: ${result.error.message || result.error}`);
            } else {
              errors.push(`Failed to save data for collection ${result.collection.name}`);
            }
          }
        });

        // Set notification based on results
        if (errorCount === 0) {
          this.notify.type = 1;
          this.notify.message = `Successfully saved ${successCount} purchase order${successCount !== 1 ? 's' : ''}.`;
        } else if (successCount === 0) {
          this.notify.type = 4;
          this.notify.errors = errors;
        } else {
          this.notify.type = 4; // Using type 4 for partial success as well
          this.notify.message = `Successfully saved ${successCount} purchase order${successCount !== 1 ? 's' : ''}.`;
          this.notify.errors = errors;
          this.purchaseStep = 1;
        }

        // Reset form and state
        this.isEdit = false;
        this.$refs.form.reset();
        this.selected_fulfillment = [];
        this.collectionList = [];
        this.satrtDate = null;
        this.endDate = null;
        this.getCollections();
        that.overlay = false;

        // Hide notification after delay if there were errors or show success
        setTimeout(() => {
          this.notify.type = 0;
        }, 3000);

        },
    getSubcriptionHistory() {
      let that = this;
      // that.overlay = true;
      // const subscriptionHistory = [];
      // new Promise((resolve, reject) => {
      //   api
      //     .getByPagin("purchase-order/organization-collection/" + this.id, { count: 10, page: 1, size: 1000, keyword: "", isIndividual: true })
      //     .then((response) => {
      //       resolve(response);
      //       console.log("order",response.data);
            that.$refs.fulfillmentStatus.open(this.tempHistory);
            // that.overlay = false;
      //     })
      //     .catch((error) => {
      //       reject(error);
      //       that.overlay = false;
      //     });
      // });
    },
    onSavePassword() {
      this.notifyPassword.errors = [];
      //this.notifyPassword.errors.splice(0, this.notify.errors.length);
      this.notifyPassword.type = 4;

      if (this.passwordHint === "") {
        this.notifyPassword.errors.push("Password hint required.");
        return true;
      }
      if (this.password === "") {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }
      if (this.password  != null && this.password.length < 6) {
        this.notifyPassword.errors.push("Password required.");
        return true;
      }

      var obj = {
        id: this.userDetails.id,
        password: this.password,
        passwordhint: this.passwordHint,
      };
      new Promise((resolve, reject) => {
        api
          .update("user/set-password", obj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.dialog = false;
              this.notify.type = 1;
              this.notify.message =
                this.userDetails.id === -1
                  ? "Password successfully saved."
                  : "Password successfully updated.";
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });

      this.dialog = false;
    },
    onOpenSetPassword() {
      this.notifyPassword.errors = [];
    },
    sortByName() {
    this.nameSortAsc = !this.nameSortAsc;
      this.list = this.list.sort((a, b) => this.nameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
    },
    sortByAddress() {
      this.addressSortAsc = !this.addressSortAsc;
      this.list = this.list.sort((a, b) => this.addressSortAsc ? a.Address.localeCompare(b.Address) : b.Address.localeCompare(a.Address));
    },
    sortByCountry() {
      this.countrySortAsc = !this.countrySortAsc;
      this.list = this.list.sort((a, b) => {
        const countryA = a.country ? a.country.CountryName : '';
        const countryB = b.country ? b.country.CountryName : '';
        return this.countrySortAsc ? countryA.localeCompare(countryB) : countryB.localeCompare(countryA);
      });
    },
    sortBySubscriptionType() {
      this.subscriptionTypeSortAsc = !this.subscriptionTypeSortAsc;
      this.list = this.list.sort((a, b) => {
        const typeA = a.subscriptionType || '';
        const typeB = b.subscriptionType || '';
        return this.subscriptionTypeSortAsc ? typeA.localeCompare(typeB) : typeB.localeCompare(typeA);
      });
    },
    sortByUserLimit() {
      this.userLimitSortAsc = !this.userLimitSortAsc;
      this.list = this.list.sort((a, b) => this.userLimitSortAsc ? a.UserLimit - b.UserLimit : b.UserLimit - a.UserLimit);
    },
     sortByLicenseLimit() {
      this.licenseLimitSortAsc = !this.licenseLimitSortAsc;
      this.list = this.list.sort((a, b) => this.licenseLimitSortAsc ? a.LicenseLimit - b.LicenseLimit : b.LicenseLimit - a.LicenseLimit);
    },
     sortByLendingDuration() {
      this.lendingDurationSortAsc = !this.lendingDurationSortAsc;
      this.list = this.list.sort((a, b) => this.lendingDurationSortAsc ? a.LendingDuration - b.LendingDuration : b.LendingDuration - a.LendingDuration);
    },
    sortByStartDate() {
      this.startDateSortAsc = !this.startDateSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = a.earliestSubscriptionStartDate ? new Date(a.earliestSubscriptionStartDate) : new Date(0);
        const dateB = b.earliestSubscriptionStartDate ? new Date(b.earliestSubscriptionStartDate) : new Date(0);
        return this.startDateSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    sortByEndDate() {
      this.endDateSortAsc = !this.endDateSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = a.earliestSubscriptionEndDate ? new Date(a.earliestSubscriptionEndDate) : new Date(0);
        const dateB = b.earliestSubscriptionEndDate ? new Date(b.earliestSubscriptionEndDate) : new Date(0);
        return this.endDateSortAsc ? dateA - dateB : dateB - dateA;
      });
    },

    async loadSubscriptionHistory() {
      if (!this.id) return;

      this.historyLoading = true;
      this.subscriptionHistory = [];

      try {
        const response = await api.getByPagin("purchase-order/organization-collection/" + this.id, { count: 10, page: 1, size: 1000, keyword: "", isIndividual: false });
        console.log("purchase",response.data)
        const purchaseOrders = response.data.data || [];

        const detailRequests = purchaseOrders.map((order) => {
          const url = order.IsCollection
            ? "purchase-order/collection/" + order.id
            : "purchase-order/publication/" + order.id;

          return api.getByPagin(url, {
            count: 10,
            page: 1,
            size: 1000,
            keyword: "",
          });
        });

      const detailResponses = await Promise.all(detailRequests);
      const allRows = [];
      const allHistory = [];
      console.log("details",detailResponses)
      purchaseOrders.forEach((order, index) => {
        const detail = detailResponses[index].data.data.forEach(data => {
          if (data) {
            // Attach purchase order fields needed for cancellation
            data.purchaseOrderId = order.id;
            data.organizationId = order.OrganizationId;
            data.isCollection = order.IsCollection;
            if (data.IsCancel === false) {
              allRows.push(data);
            }
            allHistory.push(data);
          }
        });  
      });

      this.tempHistory = allHistory;

      this.subscriptionHistory = allRows.filter((row) =>
      this.isActiveSubscriptionRow(row)
    );
    } finally {
      this.historyLoading = false;
    }
  },
  isActiveSubscriptionRow(row) {
    const now = moment();
    const startDate = moment(row.StartDate);
    const endDate = moment(row.EndDate);

    return now.isBetween(startDate, endDate, null, "[]");
  }


  },
  data() {
    return {
      id: 0,
      collectionList: [],
      subscriptionHistory: [],
      historyLoading: false,
      fulfillment_headers: [
        {
          text: "Collection",
          align: "start",
          sortable: false,
          value: "Name",
          width: "30%",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "satrtDate",
          width: "35%",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "endDate",
          width: "35%",
        },
      ],
      selected_fulfillment: [],
      purchaseStep: 1,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        isIndividual: true,
        Name: "",
        Address: "",
        UserLimit: 1,
        LicenseLimit: 0,
        LendingDuration: 14,
        phone: "",
        subscriptionAdminEmail: "",
        subscriptionType: "",
        Description: "Individual Subscription",
      },
      id: 0,
      Name: "",
      Address: "",
      UserLimit: 1,
      LicenseLimit: 0,
      LendingDuration: 14,
      phone: "",
      subscriptionAdminEmail: "",
      subscriptionType: "",
      individualRules: [(v) => !!v || "Individual Name is required"],
      userLimitRules: [(v) => !!v || "User Limit is required", v => (v && parseInt(v) > 0) || 'User Limit should be greator than zero'],
      licenseLimitRules: [(v) => !!v || "License Limit is required"],
      LendingDurationRules: [(v) => !!v || "Lending duration is required" , v => (v && parseInt(v) > 0) || 'Lending duration should be greator than zero'],
      adminEmailRules: [(v) => !!v || "Email is required"],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" , isASC: true },
      tab: null,
      overlay : false,
      password: "",
      passwordHint: "",
      reg: '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,24}))$/',
      show1: false,
      dialog: false,
      isEditPassword: false,
      passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 6) || "The password should have a minimum of 6 characters",
    ],
    userDetails: {},
    notifyPassword: {
        type: 0,
        message: "",
        errors: [],
      }
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  /* padding: 8px; */
}
</style>



// WEBPACK FOOTER //
// src/views/Individuals.vue